export default __webpack_public_path__ + "static/kamilo-7b0547e8ee524fa38a5a86448965aed9.png";